var map = {
	"./dashboard/route/index.tsx": 8840,
	"./fees-management/feeSetup/route/index.tsx": 3606,
	"./fees-management/payments/route/index.tsx": 3526,
	"./settings/personal-details/route/index.tsx": 3466,
	"./student-management/students/route/index.tsx": 5560,
	"./user-management/roles/route/index.tsx": 884,
	"./user-management/users/route/index.tsx": 9420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8126;